<template>
    <Tooltip :content="item.title" placement="right">
        <Button @click="$emit('on-select',item.name)" class="btn-dropmenu" type="text">
            <Icon :size="20" :color="color()"  :type="item.icon"></Icon>
        </Button>
    </Tooltip>
</template>
<script>
export default {
    props:{
        item:{type:Object,default:null}
    },
    methods:{
        color:()=>option[`color_${option.theme}`]
    }
}
</script>